import React, { useEffect, useRef } from 'react';
import { defaultChatBotSettings } from "../../../../consts/settings";

export function ReplyWaitIndicator({ chatBotSetting }) {
  const indicatorRef = useRef(null);

  useEffect(() => {
    indicatorRef.current?.scrollIntoView?.({ block: 'end' });
  }, []);

  return (
    <div ref={indicatorRef} className="chat-message-row mt-5" role="status" aria-label="Assistant is typing">
      <div className="chat-message-avatar">
        <img src={chatBotSetting.logo || defaultChatBotSettings.logo} alt="" />
      </div>
      <div className="chat-text-bubble chat-bot-bubble flex items-center gap-1.5 h-10" aria-hidden="true">
        {[0, 1, 2].map(index => <span key={index} className="bg-neutral-400 rounded-full h-1.5 w-1.5 animate-pulse" style={{ animationDelay: `${index * 150}ms` }} />)}
      </div>
    </div>
  );
}
